import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import _ from 'lodash';


// synchronous thunks
export function setIsWaitModalShown(bool, process = 'default') {
	return (dispatch, getState) => {
		// NOTE: the waitStack is a dictionary of processes and their counts.
		// Normally, this just uses the 'default' process.
		// Optionally, the user can tell us which process is to be shown.
		// If not using the default, the process name is added as the waitMessage.
		// If multiple processes are being awaited, the most recently added process 
		// controls the waitMessage, even if other earlier added processes have been
		// incremented.

		const stack = _.clone(selectWaitStack(getState()));
		if (bool) {
			// Show it
			if (_.isEmpty(stack)) {
				dispatch(setIsWaitModalShownAction(true));
			}
			if (stack[process]) {
				stack[process]++;
			} else {
				stack[process] = 1;
			}
		} else {
			// Hide it
			if (stack[process] !== 1) {
				stack[process]--;
			} else {
				delete stack[process];
			}
			if (_.isEmpty(stack)) {
				dispatch(setIsWaitModalShownAction(false));
			}

			const
				keys = Object.keys(stack),
				lastKey = keys[keys.length - 1];
			process = lastKey;
		}
		dispatch(setWaitStack(stack));
		dispatch(setWaitMessage(process === 'default' ? null : process));
	};
}


export const debugSlice = createSlice({
	name: 'debug',
	initialState: {
		debugMessage: null,
		debugStack: [],
		alertMessage: null,
		infoMessage: null,
		isWaitModalShown: false,
		waitMessage: null,
		waitStack: {},
	},
	reducers: {
		setDebugMessage: (state, action) => {
			state.debugMessage = action.payload
		},
		setDebugStack: (state, action) => {
			state.debugStack = action.payload
		},
		setAlertMessage: (state, action) => {
			state.alertMessage = action.payload
		},
		setInfoMessage: (state, action) => {
			state.infoMessage = action.payload
		},
		setIsWaitModalShownAction: (state, action) => {
			state.isWaitModalShown = action.payload
		},
		setWaitMessage: (state, action) => {
			state.waitMessage = action.payload
		},
		setWaitStack: (state, action) => {
			state.waitStack = action.payload
		},
		// postAdded: {
		// 	reducer(state, action) {
		// 		state.push(action.payload)
		// 	},
		// 	prepare(title, content) {
		// 		return {
		// 			payload: {
		// 				id: nanoid(),
		// 				title,
		// 				content
		// 			}
		// 		}
		// 	}
		// }
	}
});


// action definitions
export const {
	setDebugMessage,
	setDebugStack,
	setAlertMessage,
	setInfoMessage,
	setIsWaitModalShownAction,
	setWaitMessage,
	setWaitStack,
} = debugSlice.actions;


// selectors
export const selectDebugMessage = state => state.debug.debugMessage;
export const selectDebugStack = state => state.debug.debugStack;
export const selectAlertMessage = state => state.debug.alertMessage;
export const selectInfoMessage = state => state.debug.infoMessage;
export const selectIsWaitModalShown = state => state.debug.isWaitModalShown;
export const selectWaitMessage = state => state.debug.waitMessage;
export const selectWaitStack = state => state.debug.waitStack;


export default debugSlice.reducer;